"use client";

import { NumSlider } from "src/components/ui/NumSlider";
import Case from "../Case";

export const SliderExplainer = () => {
  return (
    <Case rate={7}>
      {({
        rate,
        onRateChange,
      }: {
        rate: number;
        onRateChange: (num: number | number[]) => void;
      }) => <NumSlider num={rate} onChange={onRateChange} />}
    </Case>
  );
};
